import { ServerErrorIcon } from '@p2p/assets/svg';

import { ErrorPage } from './components';

export const ServerErrorPage = () => {
  return (
    <ErrorPage
      title="Что-то пошло не так!"
      description={`Сервис временно недоступен.\nПожалуйста, попробуйте снова позже.`}
      icon={<ServerErrorIcon />}
    />
  );
};
